module.exports = __webpack_public_path__ + "static/media/empty-messages.a5827883.svg";